// import React, {
//   useState,
//   useEffect,
//   useMemo,
//   useCallback,
//   useRef,
// } from "react";
// import { UseFormReturn } from "react-hook-form";
// import { AlertCircle, CheckCircle, ChevronLeft, Info } from "lucide-react";
// import { DynamicForm } from "@shared/components/DynamicForm";
// import { FormService } from "@shared/services/FormServices";
// import { useParams, useLocation, useNavigate } from "react-router-dom";
// import {
//   useRemoteUtilityId,
//   useCurrency,
// } from "@shared/selectors/globalSelectors";
// import { useActiveUtilityServices } from "@shared/hooks/useActiveUtililyServices";
// import { useServiceChargeName, useUpdatePlanMutation } from "../../../../hooks";

// // Hardcoded options
// const SERVICE_CHARGE_TYPE_OPTIONS = [
//   { value: "variable", label: "Variable" },
//   { value: "fixed", label: "Fixed" },
// ];

// const FREQUENCY_OPTIONS = [
//   { value: "First Bill", label: "First Bill" },
//   { value: "From 2nd Bill", label: "From 2nd Bill" },
//   { value: "Last Bill", label: "Last Bill" },
//   { value: "Every Bill", label: "Every Bill" },
// ];

// // New consumption options
// const CONSUMPTION_OPTIONS = [
//   { value: "full", label: "Full" },
//   { value: "partial", label: "Partial" },
// ];

// // Type definitions
// export interface ServiceCharge {
//   charge_name: string;
//   utility_service: string;
//   charge_type: string;
//   charge_rate: number;
//   frequency: string;
//   credit_period?: number;
//   consumption?: string;
//   consumption_percentage?: number;
// }

// export interface ServiceChargesData {
//   common_charges: ServiceCharge[];
// }

// // Charge type descriptions
// const CHARGE_DESCRIPTIONS = {
//   variable:
//     "A variable charge amount that can change based on consumption or other factors.",
//   fixed:
//     "A fixed charge amount that remains constant regardless of consumption.",
// };

// interface ServiceChargesStepProps {
//   onCancel?: () => void;
//    onNext?: () => void;
//      isFirstStep?: boolean;

//   onPrevious?: () => void;
//   loading?: boolean;
//   className?: string;
//   data?: any;
//   onDataChange?: (data: any) => void;
//   setValidationError?: (error: string) => void;
//   clearValidationError?: () => void;
// }

// export const ServiceChargesStep: React.FC<ServiceChargesStepProps> = ({
//   onCancel,
//   onPrevious,
//   isFirstStep,
//   loading = false,
//   className = "",
//   onDataChange,
//   setValidationError,
//   clearValidationError,
//   data = {},
// }) => {
//   console.log(
//     "🔧 ServiceChargesStep component initialized",
//     JSON.stringify(data, null, 2)
//   );

//   // State management
//   const [formLoading, setFormLoading] = useState(false);
//   const navigate = useNavigate();
//   const [validationErrors, setValidationErrors] = useState<string[]>([]);
//   const [showValidation, setShowValidation] = useState(false);
//   const [selectedChargeType, setSelectedChargeType] = useState<
//     string | undefined
//   >();
//   const [forceRender, setForceRender] = useState(0);

//   // Refs to prevent infinite loops
//   const isUpdatingFormRef = useRef(false);
//   const lastDataRef = useRef<any>(null);

//   // Hooks for data fetching
//   const utilityId = useRemoteUtilityId();
//   const currency = useCurrency();
//   const location = useLocation();

//   // API Hooks
//   const { data: serviceChargeNames, isLoading: serviceChargeNamesLoading } =
//     useServiceChargeName();
//   const { data: activeUtilityServices } = useActiveUtilityServices();

//   const routeInitialData = location.state?.initialData;
//   const isEditMode = "edit";
//   const { planId, action } = useParams<{ planId?: string; action: string }>();
//   const parsedPlanId = planId ? Number(planId) : null;
//   const updatePlanMutation = useUpdatePlanMutation(parsedPlanId);

//   console.log(
//     "Initial data from route:",
//     JSON.stringify(routeInitialData, null, 2)
//   );

//   // 🔧 FIXED: Transform API data to form format
//   const transformedData = useMemo(() => {
//     console.log("🔧 Transforming data for service charges form:", data);

//     // If we have serviceCharges object, transform it to common_charges array
//     if (data.serviceCharges && typeof data.serviceCharges === "object") {
//       const commonCharges = Object.keys(data.serviceCharges).map(
//         (chargeKey) => {
//           const charge = data.serviceCharges[chargeKey];
//           return {
//             charge_name: charge.chargeLabel || chargeKey,
//             charge_key: chargeKey, // Store the key for later use
//             utility_service:
//               charge.utilityService || charge.utility_service || "",
//             charge_type: charge.basis || charge.charge_type || "",
//             charge_rate: parseFloat(charge.fee || charge.charge_rate || "0"),
//             frequency: charge.frequency || "",
//             credit_period: charge.creditPeriod
//               ? parseInt(charge.creditPeriod)
//               : undefined,
//             consumption: charge.consumption || "",
//             consumption_percentage: charge.consumptionPercentage
//               ? parseFloat(charge.consumptionPercentage)
//               : undefined,
//           };
//         }
//       );

//       console.log("🔧 Transformed common_charges:", commonCharges);

//       return {
//         common_charges: commonCharges,
//         // Include other properties from data
//         ...data,
//       };
//     }

//     // If data already has common_charges array, use it as is
//     if (data.common_charges && Array.isArray(data.common_charges)) {
//       return data;
//     }

//     // Default empty structure
//     return {
//       common_charges: [],
//       ...data,
//     };
//   }, [data]);

//   // Get step 3 selected services from localStorage
//   const getStep3SelectedServices = useCallback(() => {
//     try {
//       const progressData = localStorage.getItem(
//         `utility-plan-progress-${planId}`
//       );
//       console.log("progressData", JSON.parse(progressData));
//       if (progressData) {
//         const parsed = JSON.parse(progressData);
//         console.log("parsed", parsed);
//         const step3Data = parsed.stepData?.[2]; // Step 3 is index 2
//         return step3Data?.selectedServices || step3Data?.utilityService || [];
//       }
//     } catch (error) {
//       console.error("Error reading from localStorage:", error);
//     }
//     return [];
//   }, [planId]);

//   // Get non-metered services from step 3 - MEMOIZED PROPERLY
//   const nonMeteredServicesFromStep3 = useMemo(() => {
//     const step3Services = getStep3SelectedServices(); // e.g. ["Water", "Gas"]
//     console.log("🔍 Step 3 Selected Services:", step3Services);

//     if (!activeUtilityServices || step3Services.length === 0) {
//       return [];
//     }

//     const nonMeteredServices = activeUtilityServices.filter((service) => {
//       const isSelectedInStep3 = step3Services.includes(service.name);
//       const isNonMetered = !service.isMeterRequired;
//       return isSelectedInStep3 && isNonMetered;
//     });

//     console.log("✅ Non-metered services from step 3:", nonMeteredServices);
//     return nonMeteredServices;
//   }, [activeUtilityServices, planId]); // Remove getStep3SelectedServices from deps

//   // Create Service Charge Name options - combined with non-metered services from step 3
//   const serviceChargeNameOptions = useMemo(() => {
//     const options = [];

//     // Add service charge names from API
//     if (serviceChargeNames && !serviceChargeNamesLoading) {
//       const apiChargeNames = serviceChargeNames
//         .filter((item: any) => item.isActive)
//         .map((item: any) => ({
//           label: item.name,
//           value: item.name,
//         }));
//       options.push(...apiChargeNames);
//     }

//     // Add non-metered services from step 3
//     const serviceOptions = nonMeteredServicesFromStep3.map((service) => ({
//       label: service.name,
//       value: service.name,
//     }));
//     options.push(...serviceOptions);

//     return options;
//   }, [
//     serviceChargeNames,
//     serviceChargeNamesLoading,
//     nonMeteredServicesFromStep3,
//   ]);

//   // Create Utility Service options - all active utility services + Common
//   const utilityServiceOptions = useMemo(() => {
//     const options = [];

//     // Add "Common" option first
//     options.push({ label: "Common", value: "Common" });

//     // Add all active utility services
//     if (activeUtilityServices && activeUtilityServices.length > 0) {
//       const serviceOptions = activeUtilityServices.map((service) => ({
//         label: service.name,
//         value: service.name,
//       }));
//       options.push(...serviceOptions);
//     }

//     return options;
//   }, [activeUtilityServices]);

//   // 🔧 FIXED: Create default values from transformed data - STABLE REFERENCE
//   const getDefaultValues = useMemo(() => {
//     console.log(
//       "🔧Creating default values from transformed data:",
//       transformedData
//     );
//     return {
//       common_charges: transformedData.common_charges || [],
//     };
//   }, [transformedData]);

//   // 🔧 FIXED: Helper functions to check charge types - MEMOIZED
//   const isLatePaymentCharge = useCallback((chargeName: string) => {
//     if (!chargeName) return false;
//     return (
//       chargeName.toLowerCase().includes("late payment") ||
//       chargeName.toLowerCase().includes("late_payment")
//     );
//   }, []);

//   const isNonMeteredServiceCharge = useCallback(
//     (chargeName: string) => {
//       if (!chargeName) return false;
//       return nonMeteredServicesFromStep3.some(
//         (service) => service.name === chargeName
//       );
//     },
//     [nonMeteredServicesFromStep3]
//   );

//   // Service charges field definition
//   const createServiceChargesField = useCallback(
//     () => ({
//       name: "common_charges",
//       // label: "Common Service Charges",
//       type: "form-array" as const,
//       required: false,
//       fullWidth: true,
//       // group: "Service Charges",
//       // groupColorNeeded: false,
//       // groupOrder: 1,
//       // helperText: "These charges apply to all services",
//       minItems: 0,
//       addButtonText: "Add Charge",
//       emptyMessage:
//         "No service charges defined yet. Click 'Add Charge' to add charges.",
//       showAddButton: true,
//       showRemoveButton: true,
//       showReorderButtons: false,
//       itemFields: [
//         // Field 1: Service Charge Name
//         {
//           name: "charge_name",
//           label: "Service Charge Name",
//           type: "select" as const,
//           required: true,
//           placeholder: "Select a charge name or service charge.",
//           options: serviceChargeNameOptions,
//           helperText:
//             "Select a predefined charge name or service-specific charge.",
//           disabled: serviceChargeNamesLoading,
//           showWhen: (formData: any, fieldPath?: string) =>
//             getFieldVisibility("charge_name", formData, fieldPath),
//         },
//         // Field 2: Utility Service
//         {
//           name: "utility_service",
//           label: "Utility Service",
//           type: "select" as const,
//           required: false,
//           placeholder: "Select utility service",
//           options: utilityServiceOptions,
//           helperText: "Select the utility service this charge applies to.",
//           showWhen: (formData: any, fieldPath?: string) =>
//             getFieldVisibility("utility_service", formData, fieldPath),
//         },
//         // Field 3: Service Charge Type
//         {
//           name: "charge_type",
//           label: "Service Charge Type",
//           type: "select" as const,
//           required: false,
//           placeholder: "Select charge type",
//           options: SERVICE_CHARGE_TYPE_OPTIONS,
//           helperText: "Define if the charge is fixed or variable.",
//           showWhen: (formData: any, fieldPath?: string) =>
//             getFieldVisibility("charge_type", formData, fieldPath),
//         },
//         // Field 4: Service Charge Rate
//         {
//           name: "charge_rate",
//           label: `Service Charge Rate`,
//           type: "decimal" as const,
//           required: false,

//           placeholder: "0.00",
//           // prefix: currency || "$",
//           helperText: "Enter the rate amount for this charge.",
//           showWhen: (formData: any, fieldPath?: string) =>
//             getFieldVisibility("charge_rate", formData, fieldPath),
//         },
//         // Field 5: Frequency
//         {
//           name: "frequency",
//           label: "Frequency",
//           type: "select" as const,
//           required: false,
//           placeholder: "Select frequency",
//           options: FREQUENCY_OPTIONS,
//           helperText: "When this charge is applied.",
//           showWhen: (formData: any, fieldPath?: string) =>
//             getFieldVisibility("frequency", formData, fieldPath),
//         },
//         // Field 6: Credit Period (only for Late Payment charges)
//         {
//           name: "credit_period",
//           label: "Credit Period",
//           type: "number" as const,
//           required: false,
//           placeholder: "30",

//           suffix: "days",
//           helperText: "Grace period before late payment charge applies.",
//           showWhen: (formData: any, fieldPath?: string) =>
//             getFieldVisibility("credit_period", formData, fieldPath),
//         },
//         // Field 7: Consumption (only for non-metered services)
//         {
//           name: "consumption",
//           label: "Consumption",
//           type: "select" as const,
//           required: false,
//           placeholder: "Select consumption type",
//           options: CONSUMPTION_OPTIONS,
//           helperText: "Select how consumption is calculated for this service.",
//           showWhen: (formData: any, fieldPath?: string) =>
//             getFieldVisibility("consumption", formData, fieldPath),
//         },
//         // Field 8: Consumption Percentage (only when consumption is partial)
//         {
//           name: "consumption_percentage",
//           label: "Consumption Percentage",
//           type: "number",
//           required: false,
//           placeholder: "50",
//           min: 1,
//           max: 100,
//           suffix: "%",
//           helperText: "Enter the percentage of consumption to be charged.",
//           showWhen: (formData: any, fieldPath?: string) =>
//             getFieldVisibility("consumption_percentage", formData, fieldPath),
//         },
//       ],

//       classes: {
//         container: "w-full mb-8 col-span-2",
//         label: "block text-lg font-semibold text-gray-900 mb-2",
//         error: "text-red-600 text-sm mt-1",
//       },
//     }),
//     [
//       serviceChargeNameOptions,
//       utilityServiceOptions,
//       currency,
//       serviceChargeNamesLoading,
//       isLatePaymentCharge,
//       isNonMeteredServiceCharge,
//     ]
//   );

//   // Generate form fields
//   const generateFormFields = useCallback(() => {
//     const serviceChargesField = createServiceChargesField();
//     return [serviceChargesField] as any[];
//   }, [createServiceChargesField]);

//   // Create form configuration with ALL possible fields
//   const allPossibleFields = useMemo(() => {
//     return generateFormFields();
//   }, [generateFormFields]);

//   // Create form instance
//   const form: UseFormReturn<any> = FormService.createForm({
//     fields: allPossibleFields,
//     defaultValues: getDefaultValues,
//     mode: "onBlur" as const,
//     layout: "vertical" as const,
//     spacing: "comfortable" as const,
//     showProgress: true,
//     showResetButton: false,
//     showSubmitButton: false,
//   });

//   // Get current fields to display
//   const currentFields = useMemo(() => {
//     return generateFormFields();
//   }, [generateFormFields]);

//   // 🔧 FIXED: Update form values when data changes - PREVENT INFINITE LOOPS
//   useEffect(() => {
//     // Prevent update if we're already updating or data hasn't changed
//     if (
//       isUpdatingFormRef.current ||
//       JSON.stringify(data) === JSON.stringify(lastDataRef.current)
//     ) {
//       return;
//     }

//     console.log("🔄 Data changed, updating form values:", getDefaultValues);

//     lastDataRef.current = data;
//     isUpdatingFormRef.current = true;

//     try {
//       // Reset form with new values when data changes
//       Object.keys(getDefaultValues).forEach((key) => {
//         const value = getDefaultValues[key as keyof typeof getDefaultValues];
//         if (value !== undefined && value !== null) {
//           const currentValue = form.getValues(key);
//           if (JSON.stringify(currentValue) !== JSON.stringify(value)) {
//             form.setValue(key, value, {
//               shouldValidate: false,
//               shouldDirty: false,
//             });
//             console.log(`📝 Set ${key} = ${JSON.stringify(value)}`);
//           }
//         }
//       });
//     } finally {
//       // Reset the flag after a delay to allow the update to complete
//       setTimeout(() => {
//         isUpdatingFormRef.current = false;
//       }, 100);
//     }
//   }, [data]); // Only depend on data, not the computed values

//   // 🔧 NEW: Real-time field visibility updates
//   useEffect(() => {
//     const subscription = form.watch((value, { name, type }) => {
//       // Only trigger on specific field changes that affect visibility
//       if (
//         name &&
//         (name.includes("charge_name") || name.includes("consumption"))
//       ) {
//         console.log(`🔄 Real-time update triggered by: ${name}`);

//         // Small delay to allow form state to stabilize
//         setTimeout(() => {
//           setForceRender((prev) => prev + 1);
//         }, 5);
//       }
//     });

//     return () => subscription.unsubscribe();
//   }, [form]);

//   // 🔧 SIMPLE: Centralized showWhen logic
//   const getFieldVisibility = useCallback(
//     (fieldName: string, formData: any, fieldPath?: string) => {
//       console.log('fieldPath from frunction',fieldPath)
//       // Extract charge name and consumption from path
//       let chargeName = "";
//       let consumption = "";
//       if (fieldPath) {
//         const pathMatch = fieldPath.match(/common_charges\.(\d+)\./);
//       console.log('fieldPath pathMatch ',pathMatch)

//         // if (pathMatch) {
//           // const index = parseInt(pathMatch[1]);
//           // const chargeItem = formData.common_charges?.[index];
//           chargeName = formData?.charge_name || "";
//           consumption = formData?.consumption || "";
//         // }
//       }

//       const isNonMetered = isNonMeteredServiceCharge(chargeName);
//       const isLatePayment = isLatePaymentCharge(chargeName);
//       const isPartialConsumption = consumption === "partial";

//       console.log(
//         `🔍 Visibility check: ${fieldName} | Charge: ${chargeName} | NonMetered: ${isNonMetered} | Consumption: ${consumption}`
//       );

//       // Non-metered service mode: Only show charge_name, consumption, and consumption_percentage
//       if (isNonMetered) {
//         switch (fieldName) {
//           case "charge_name":
//           case "consumption":
//           case "utility_service":
//             return true;
//           case "consumption_percentage":
//             return isPartialConsumption;
//           default:
//             return false; // Hide all other fields for non-metered services
//         }
//       }

//       // Late payment mode: Show basic fields + credit_period
//       if (isLatePayment) {
//         const latePaymentFields = [
//           "charge_name",
//           "utility_service",
//           "charge_type",
//           "charge_rate",
//           "frequency",
//           "credit_period",
//         ];
//         return latePaymentFields.includes(fieldName);
//       }

//       // Default mode: Show basic fields only
//       const basicFields = [
//         "charge_name",
//         "utility_service",
//         "charge_type",
//         "charge_rate",
//         "frequency",
//       ];

//       return basicFields.includes(fieldName);
//     },
//     [isLatePaymentCharge, isNonMeteredServiceCharge]
//   );

//   const handleFieldChange = useCallback(
//     (fieldName: string, value: any) => {
//       if (isUpdatingFormRef.current) return;

//       console.log(`🔄 Field ${fieldName} changed to:`, value);

//       // Clear validation errors
//       if (showValidation) {
//         setShowValidation(false);
//         setValidationErrors([]);
//       }

//       // Handle charge type for info display
//       if (fieldName.includes("charge_type")) {
//         setSelectedChargeType(value);
//       }

//       // 🔧 FIXED: Only clear fields when necessary, not on every change
//       if (fieldName.includes("charge_name")) {
//         console.log("🔧 Charge name changed, updating conditional fields...");

//         const pathMatch = fieldName.match(/common_charges\.(\d+)\./);
//         if (pathMatch) {
//           const index = parseInt(pathMatch[1]);

//           setTimeout(() => {
//             if (!isUpdatingFormRef.current) {
//               isUpdatingFormRef.current = true;

//               try {
//                 // Only clear fields if the new selection doesn't support them
//                 if (!isLatePaymentCharge(value)) {
//                   form.setValue(
//                     `common_charges.${index}.credit_period`,
//                     undefined,
//                     {
//                       shouldValidate: false,
//                       shouldDirty: false,
//                     }
//                   );
//                 }

//                 if (!isNonMeteredServiceCharge(value)) {
//                   form.setValue(`common_charges.${index}.consumption`, "", {
//                     shouldValidate: false,
//                     shouldDirty: false,
//                   });
//                   form.setValue(
//                     `common_charges.${index}.consumption_percentage`,
//                     undefined,
//                     {
//                       shouldValidate: false,
//                       shouldDirty: false,
//                     }
//                   );
//                 }
//               } finally {
//                 setTimeout(() => {
//                   isUpdatingFormRef.current = false;
//                   // Force re-render after clearing
//                   setForceRender((prev) => prev + 1);
//                 }, 50);
//               }
//             }
//           }, 10);
//         }
//       }

//       // 🔧 FIXED: Only clear consumption_percentage when consumption changes to non-partial
//       else if (
//         fieldName.includes("consumption") &&
//         !fieldName.includes("consumption_percentage")
//       ) {
//         console.log("🔧 Consumption changed, checking percentage field...");

//         if (value !== "partial") {
//           const pathMatch = fieldName.match(/common_charges\.(\d+)\./);
//           if (pathMatch) {
//             const index = parseInt(pathMatch[1]);
//             setTimeout(() => {
//               if (!isUpdatingFormRef.current) {
//                 form.setValue(
//                   `common_charges.${index}.consumption_percentage`,
//                   undefined,
//                   {
//                     shouldValidate: false,
//                     shouldDirty: false,
//                   }
//                 );
//                 setForceRender((prev) => prev + 1);
//               }
//             }, 10);
//           }
//         } else {
//           // Just force re-render to show the percentage field
//           setForceRender((prev) => prev + 1);
//         }
//       }

//       // 🔧 NEW: For consumption_percentage changes, just update without clearing
//       else if (fieldName.includes("consumption_percentage")) {
//         console.log("🔧 Consumption percentage changed, no clearing needed");
//         // Don't clear anything, just let the value persist
//       }

//       // 🔧 FIXED: Force immediate re-render for conditional field visibility
//       else {
//         setForceRender((prev) => prev + 1);
//       }

//       // Update parent data with debounce
//       setTimeout(() => {
//         if (!isUpdatingFormRef.current) {
//           const currentFormData = form.getValues();
//           onDataChange?.(currentFormData);
//         }
//       }, 100);
//     },
//     [
//       showValidation,
//       form,
//       onDataChange,
//       isLatePaymentCharge,
//       isNonMeteredServiceCharge,
//     ]
//   );

//   const transformToApiPayload = (formData: any): any => {
//     console.log("--- TRANSFORM SERVICE CHARGES TO API PAYLOAD ---");
//     console.log("Input form data:", formData);

//     const utilityServiceCharges: Record<string, any> = {};

//     (formData.common_charges || []).forEach((charge: any) => {
//       const key = charge.charge_key || charge.charge_name; // use key if available
//       console.log("show the key", key);

//       console.log(`🔧 Processing charge:`, {
//         keyUsed: key,
//         fullCharge: charge,
//       });

//       utilityServiceCharges[key] = {
//         chargeLabel: charge.charge_name, // label goes here
//         utility_service: charge.utility_service || null,
//         fee: charge.charge_rate != null ? String(charge.charge_rate) : null,
//         frequency: charge.frequency || null,
//         basis: charge.charge_type || null,
//         creditPeriod:
//         charge.credit_period != null ? String(charge.credit_period) : null,
//         operation: "addition",
//         // Add new consumption fields
//         ...(charge.consumption && { consumption: charge.consumption }),
//         ...(charge.consumption_percentage != null && {
//           consumption_percentage: String(charge.consumption_percentage),
//         }),
//         ...(utilityId &&
//           key.toLowerCase().includes("late_payment") && {
//             remote_utility_id: utilityId,
//           }),
//       };
//     });

//     const payload = {
//       extra_charges: {
//         utility_service_charges: utilityServiceCharges,
//       },
//       current_step: 4,
//     };

//     console.log(
//       "✅ Final transformed payload:",
//       JSON.stringify(payload, null, 2)
//     );
//     return payload;
//   };

//   // Business rules validation
//   const validateServiceChargesData = (
//     data: any
//   ): { isValid: boolean; errors: string[] } => {
//     const errors: string[] = [];
//     console.log("--- VALIDATE SERVICE CHARGES DATA ---");
//     console.log("Input data for validation:", data);

//     // Service charges validation
//     if (data.common_charges && data.common_charges.length > 0) {
//       data.common_charges.forEach((charge: any, index: number) => {
//         if (!charge.charge_name || charge.charge_name === "") {
//           errors.push(`Service charge ${index + 1}: Charge name is required`);
//         }
//         if (!charge.utility_service || charge.utility_service === "") {
//           errors.push(
//             `Service charge ${index + 1}: Utility service is required`
//           );
//         }
//         if (!charge.charge_type || charge.charge_type === "") {
//           errors.push(`Service charge ${index + 1}: Charge type is required`);
//         }
//         if (!charge.charge_rate || charge.charge_rate <= 0) {
//           errors.push(
//             `Service charge ${index + 1}: Charge rate must be greater than 0`
//           );
//         }
//         if (!charge.frequency || charge.frequency === "") {
//           errors.push(`Service charge ${index + 1}: Frequency is required`);
//         }

//         // Credit period validation - only for late payment charges
//         if (isLatePaymentCharge(charge.charge_name)) {
//           if (
//             !charge.credit_period ||
//             charge.credit_period < 1 ||
//             charge.credit_period > 365
//           ) {
//             errors.push(
//               `Service charge ${
//                 index + 1
//               }: Credit period must be between 1 and 365 days for late payment charges`
//             );
//           }
//         }

//         // Consumption percentage validation - only when consumption is partial
//         if (charge.consumption === "partial") {
//           if (!charge.consumption_percentage) {
//             errors.push(
//               `Service charge ${
//                 index + 1
//               }: Consumption percentage must be between 1 and 100 when consumption type is partial`
//             );
//           }
//         }
//       });

//       // Check for duplicate charge names within same utility service
//       const combinations = data.common_charges.map(
//         (charge: any) => `${charge.charge_name}-${charge.utility_service}`
//       );
//       const duplicates = combinations.filter(
//         (combo: string, index: number) => combinations.indexOf(combo) !== index
//       );
//       if (duplicates.length > 0) {
//         errors.push(
//           "Duplicate charge name and utility service combinations are not allowed"
//         );
//       }
//     }

//     return { isValid: errors.length === 0, errors };
//   };

//   const handleSubmit = async (formData: any) => {
//     console.log("=== SERVICE CHARGES FINAL STEP SUBMISSION START ===");
//     console.log("🟡 Raw form data:", formData);

//     try {
//       const payload = transformToApiPayload(formData);
//       console.log("🔄 Transformed payload:", payload);

//       const validation = validateServiceChargesData(formData);
//       // if (!validation.isValid) {
//       //   console.log("❌ Validation failed:", validation.errors);
//       //   setValidationErrors(validation.errors);
//       //   setShowValidation(true);
//       //   return;
//       // }

//       setValidationErrors([]);
//       setShowValidation(false);
//       setFormLoading(true);

//       // 🔁 API call or mutation
//       updatePlanMutation.mutate(payload, {
//         onSuccess: (response) => {
//           console.log("✅ Service charges updated:", response);

//           // Merge original form and API response to pass forward
//           const dataForNextStep = {
//             ...formData,
//             apiResponse: response,
//           };

//           onDataChange?.(dataForNextStep); // ⏩ pass data forward
//           navigate("/plan-tarrif/plan-tarrif-landing?tab=plans"); // Navigate to next step
//         },
//         onError: (err) => {
//           console.error("❌ Error updating service charges:", err);
//           setValidationError?.(
//             "Failed to save service charges. Please try again."
//           );
//         },
//         onSettled: () => {
//           setFormLoading(false);
//         },
//       });
//     } catch (error) {
//       console.error("❌ Unexpected error in service charges submit:", error);
//       setValidationError?.("Unexpected error occurred. Please try again.");
//       setFormLoading(false);
//     }
//   };

//   // Handle form cancel/reset
//   const handleCancel = useCallback(() => {
//     form.reset();
//     setValidationErrors([]);
//     setShowValidation(false);
//     onCancel?.();
//   }, [form, onCancel]);

//   // Custom footer with validation and actions
//   const renderCustomFooter = useCallback(
//     () => (
//       <div className="space-y-4">
//         {/* Loading state for service charge names */}
//         {serviceChargeNamesLoading && (
//           <div className="p-3 bg-blue-50 border border-blue-200 rounded-md">
//             <p className="text-sm text-blue-800">
//               <strong>Loading:</strong> Fetching service charge names from
//               API...
//             </p>
//           </div>
//         )}

//         {/* Validation Errors */}
//         {showValidation && validationErrors.length > 0 && (
//           <div className="p-4 bg-red-50 border border-red-200 rounded-md">
//             <div className="flex items-start">
//               <AlertCircle className="w-5 h-5 text-red-500 mt-0.5 mr-3 flex-shrink-0" />
//               <div>
//                 <h4 className="text-sm font-medium text-red-800">
//                   Validation Errors
//                 </h4>
//                 <ul className="mt-2 space-y-1">
//                   {validationErrors.map((error, index) => (
//                     <li key={index} className="text-sm text-red-700">
//                       • {error}
//                     </li>
//                   ))}
//                 </ul>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Charge Type Information */}
//         {selectedChargeType && CHARGE_DESCRIPTIONS[selectedChargeType] && (
//           <div className="p-4 bg-blue-50 border border-blue-200 rounded-md">
//             <div className="flex items-start">
//               <Info className="w-5 h-5 text-blue-500 mt-0.5 mr-3 flex-shrink-0" />
//               <div>
//                 <h4 className="text-sm font-medium text-blue-800">
//                   About {selectedChargeType} Charges
//                 </h4>
//                 <p className="mt-1 text-sm text-blue-700">
//                   {CHARGE_DESCRIPTIONS[selectedChargeType]}
//                 </p>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Form Actions */}
//         <div className="flex gap-3 pt-6 border-t border-gray-200">
//           {/* <button
//             type="button"
//             onClick={handleCancel}
//             disabled={formLoading || loading}
//             className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 transition-colors"
//           >
//             Cancel
//           </button> */}

//           <button
//             type="button"
//             onClick={onPrevious}
//             disabled={isFirstStep}
//             className="px-4 py-2 text-gray-600 bg-gray-100 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-200 transition-colors"
//           >
//             <ChevronLeft className="inline w-4 h-4 mr-1" />
//             Previous
//           </button>

//           <button
//             type="submit"
//             disabled={formLoading || loading || serviceChargeNamesLoading}
//             className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 flex items-center gap-2 transition-colors"
//           >
//             {(formLoading || loading) && (
//               <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
//             )}
//             {formLoading || loading ? (
//               "Saving..."
//             ) : (
//               <>
//                 <CheckCircle className="w-4 h-4" />
//                 {isEditMode ? "Update Service Charges" : "Save Service Charges"}
//               </>
//             )}
//           </button>
//         </div>
//       </div>
//     ),
//     [
//       showValidation,
//       validationErrors,
//       selectedChargeType,
//       formLoading,
//       loading,
//       isEditMode,
//       serviceChargeNamesLoading,
//       handleCancel,
//     ]
//   );

//   // Debug mode information
//   useEffect(() => {
//     console.log("🔍 ServiceChargesStep state update:", {
//       hasData: Object.keys(data).length > 0,
//       originalData: data,
//       transformedData,
//       defaultValues: getDefaultValues,
//     });
//   }, [data, transformedData, getDefaultValues]);

//   return (
//     <div className="flex flex-col gap-5">
//       <DynamicForm
//         key={forceRender} // This ensures the form re-renders when forceRender changes
//         fields={currentFields}
//         form={form}
//         onSubmit={handleSubmit}
//         loading={formLoading || loading}
//         onFieldChange={handleFieldChange}
//         renderCustomFooter={renderCustomFooter}
//         gridColumns={1}
//         responsiveColumns={{ sm: 1, md: 2, lg: 2, xl: 2 }}
//         config={{
//           layout: "vertical",
//           spacing: "comfortable",
//           showResetButton: false,
//           showSubmitButton: false,
//         }}
//       />

//       {/* Debug Section===> DON'T REMOVE below commmented code-->Onkar Pathak */}
//       {/* <div className="max-w-4xl mx-auto mt-8">
//         <details className="bg-gray-50 border border-gray-200 rounded-lg p-4">
//           <summary className="cursor-pointer text-sm font-medium text-gray-700 hover:text-gray-900">
//             Debug: Current Form Values & Data Sources
//           </summary>
//           <div className="mt-2 space-y-4">
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//               <div>
//                 <h4 className="font-medium text-gray-700 mb-2">
//                   Service Charge Names (API + Step 3 Non-Metered)
//                 </h4>
//                 <pre className="text-xs text-gray-600 bg-white p-2 rounded overflow-auto max-h-32">
//                   {JSON.stringify(serviceChargeNameOptions, null, 2)}
//                 </pre>
//               </div>
//               <div>
//                 <h4 className="font-medium text-gray-700 mb-2">
//                   Utility Service Options (All Active + Common)
//                 </h4>
//                 <pre className="text-xs text-gray-600 bg-white p-2 rounded overflow-auto max-h-32">
//                   {JSON.stringify(utilityServiceOptions, null, 2)}
//                 </pre>
//               </div>
//             </div>
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//               <div>
//                 <h4 className="font-medium text-gray-700 mb-2">
//                   Step 3 Selected Services
//                 </h4>
//                 <pre className="text-xs text-gray-600 bg-white p-2 rounded overflow-auto max-h-32">
//                   {JSON.stringify(getStep3SelectedServices(), null, 2)}
//                 </pre>
//               </div>
//               <div>
//                 <h4 className="font-medium text-gray-700 mb-2">
//                   Non-Metered Services from Step 3
//                 </h4>
//                 <pre className="text-xs text-gray-600 bg-white p-2 rounded overflow-auto max-h-32">
//                   {JSON.stringify(nonMeteredServicesFromStep3, null, 2)}
//                 </pre>
//               </div>
//             </div>
//             <div>
//               <h4 className="font-medium text-gray-700 mb-2">
//                 Current Form Values & Array Operations Debug
//               </h4>
//               <pre className="text-xs text-gray-600 bg-white p-3 rounded overflow-auto max-h-64">
//                 {JSON.stringify(
//                   {
//                     formValues: form.watch(),
//                     formErrors: form.formState.errors,
//                     arrayLength: form.watch("common_charges")?.length || 0,
//                     lastFormUpdate: new Date().toISOString(),
//                   },
//                   null,
//                   2
//                 )}
//               </pre>
//             </div>
//             <div>
//               <h4 className="font-medium text-gray-700 mb-2">
//                 Field Change Debug Info
//               </h4>
//               <div className="text-xs text-gray-600 bg-white p-3 rounded">
//                 <p>
//                   <strong>Late Payment Charges:</strong>{" "}
//                   {serviceChargeNameOptions
//                     .filter((opt) => isLatePaymentCharge(opt.value))
//                     .map((opt) => opt.label)
//                     .join(", ") || "None"}
//                 </p>
//                 <p>
//                   <strong>Non-Metered Services:</strong>{" "}
//                   {nonMeteredServicesFromStep3.map((s) => s.name).join(", ") ||
//                     "None"}
//                 </p>
//                 <p>
//                   <strong>Consumption Options:</strong>{" "}
//                   {CONSUMPTION_OPTIONS.map((opt) => opt.label).join(", ")}
//                 </p>
//               </div>
//             </div>
//             <div>
//               <h4 className="font-medium text-gray-700 mb-2">
//                 🔧 Live Form Array Debug
//               </h4>
//               <div className="text-xs text-gray-600 bg-white p-3 rounded space-y-2">
//                 <p>
//                   <strong>Form Array Length:</strong>{" "}
//                   {form.watch("common_charges")?.length || 0}
//                 </p>
//                 <p>
//                   <strong>Service Options Count:</strong>{" "}
//                   {serviceChargeNameOptions.length}
//                 </p>
//                 <p>
//                   <strong>Loading State:</strong>{" "}
//                   {serviceChargeNamesLoading ? "Loading..." : "Ready"}
//                 </p>
//                 <p>
//                   <strong>Form Valid:</strong>{" "}
//                   {form.formState.isValid ? "Yes" : "No"}
//                 </p>
//                 <p>
//                   <strong>Form Dirty:</strong>{" "}
//                   {form.formState.isDirty ? "Yes" : "No"}
//                 </p>
//                 <button
//                   type="button"
//                   onClick={() => {
//                     console.log("🔧 Manual debug - current form state:", {
//                       values: form.getValues(),
//                       errors: form.formState.errors,
//                       isDirty: form.formState.isDirty,
//                       isValid: form.formState.isValid,
//                     });
//                   }}
//                   className="px-2 py-1 bg-blue-100 text-blue-800 rounded text-xs hover:bg-blue-200"
//                 >
//                   Log Form State
//                 </button>
//               </div>
//             </div>
//             <div>
//               <h4 className="font-medium text-gray-700 mb-2">
//                 ShowWhen Logic Test
//               </h4>
//               <div className="text-xs text-gray-600 bg-white p-3 rounded space-y-2">
//                 {form
//                   .watch("common_charges")
//                   ?.map((charge: any, index: number) => (
//                     <div key={index} className="border-b pb-2">
//                       <p>
//                         <strong>Charge {index + 1}:</strong>{" "}
//                         {charge.charge_name || "Not selected"}
//                       </p>
//                       <p>
//                         • Is Late Payment:{" "}
//                         {isLatePaymentCharge(charge.charge_name) ? "Yes" : "No"}
//                       </p>
//                       <p>
//                         • Is Non-Metered:{" "}
//                         {isNonMeteredServiceCharge(charge.charge_name)
//                           ? "Yes"
//                           : "No"}
//                       </p>
//                       <p>
//                         • Show Credit Period:{" "}
//                         {isLatePaymentCharge(charge.charge_name) ? "Yes" : "No"}
//                       </p>
//                       <p>
//                         • Show Consumption:{" "}
//                         {isNonMeteredServiceCharge(charge.charge_name)
//                           ? "Yes"
//                           : "No"}
//                       </p>
//                       <p>
//                         • Show Consumption %:{" "}
//                         {isNonMeteredServiceCharge(charge.charge_name) &&
//                         charge.consumption === "partial"
//                           ? "Yes"
//                           : "No"}
//                       </p>
//                     </div>
//                   )) || <p>No charges added yet</p>}
//               </div>
//             </div>
//           </div>
//         </details>
//       </div> */}
//     </div>
//   );
// };

// export default ServiceChargesStep;



import React, { useState, useEffect, useMemo, useCallback } from "react";
import { UseFormReturn } from "react-hook-form";
import { AlertCircle, CheckCircle, ChevronLeft, Info } from "lucide-react";
import { DynamicForm } from "@shared/components/DynamicForm";
import { FormService, FormField } from "@shared/services/FormServices";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import {
  useRemoteUtilityId,
  useCurrency,
} from "@shared/selectors/globalSelectors";
import { useActiveUtilityServices } from "@shared/hooks/useActiveUtililyServices";
import { useServiceChargeName, useUpdatePlanMutation } from "../../../../hooks";

// Hardcoded options
const SERVICE_CHARGE_TYPE_OPTIONS = [
  { value: "variable", label: "Variable" },
  { value: "fixed", label: "Fixed" },
];

const FREQUENCY_OPTIONS = [
  { value: "First Bill", label: "First Bill" },
  { value: "From 2nd Bill", label: "From 2nd Bill" },
  { value: "Last Bill", label: "Last Bill" },
  { value: "Every Bill", label: "Every Bill" },
];

const CONSUMPTION_OPTIONS = [
  { value: "full", label: "Full" },
  { value: "partial", label: "Partial" },
];

// Type definitions
export interface ServiceCharge {
  charge_name: string;
  charge_key?: string;
  utility_service: string;
  charge_type: string;
  charge_rate: number;
  frequency: string;
  credit_period?: number;
  consumption?: string;
  consumption_percentage?: number;
}

export interface ServiceChargesData {
  common_charges: ServiceCharge[];
}

// Charge type descriptions
const CHARGE_DESCRIPTIONS = {
  variable:
    "A variable charge amount that can change based on consumption or other factors.",
  fixed:
    "A fixed charge amount that remains constant regardless of consumption.",
};

interface ServiceChargesStepProps {
  onCancel?: () => void;
  onNext?: () => void;
  isFirstStep?: boolean;
  onPrevious?: () => void;
  loading?: boolean;
  className?: string;
  data?: any;
  onDataChange?: (data: any) => void;
  setValidationError?: (error: string) => void;
  clearValidationError?: () => void;
}

export const ServiceChargesStep: React.FC<ServiceChargesStepProps> = ({
  onCancel,
  onPrevious,
  isFirstStep,
  loading = false,
  className = "",
  onDataChange,
  setValidationError,
  clearValidationError,
  data = {},
}) => {
  // State management
  const [formLoading, setFormLoading] = useState(false);
  const navigate = useNavigate();
  const [validationErrors, setValidationErrors] = useState<string[]>([]);
  const [showValidation, setShowValidation] = useState(false);
  const [selectedChargeType, setSelectedChargeType] = useState<
    string | undefined
  >();

  // Hooks for data fetching
  const utilityId = useRemoteUtilityId();
  const currency = useCurrency();
  const location = useLocation();

  // API Hooks
  const { data: serviceChargeNames, isLoading: serviceChargeNamesLoading } =
    useServiceChargeName();
  const { data: activeUtilityServices } = useActiveUtilityServices();

  const routeInitialData = location.state?.initialData;
  const isEditMode = "edit";
  const { planId, action } = useParams<{ planId?: string; action: string }>();
  const parsedPlanId = planId ? Number(planId) : null;
  const updatePlanMutation = useUpdatePlanMutation(parsedPlanId);

  // Local state for form data (similar to OperationsStep)
  const [localFormData, setLocalFormData] = useState<ServiceChargesData>({
    common_charges: [],
  });

  // Get step 3 selected services from localStorage
  const getStep3SelectedServices = useCallback(() => {
    try {
      const progressData = localStorage.getItem(
        `utility-plan-progress-${planId}`
      );
      if (progressData) {
        const parsed = JSON.parse(progressData);
        const step3Data = parsed.stepData?.[2];
        return step3Data?.selectedServices || step3Data?.utilityService || [];
      }
    } catch (error) {
      console.error("Error reading from localStorage:", error);
    }
    return [];
  }, [planId]);

  // Get non-metered services from step 3 - STABLE
  const nonMeteredServicesFromStep3 = useMemo(() => {
    const step3Services = getStep3SelectedServices();
    if (!activeUtilityServices || step3Services.length === 0) {
      return [];
    }

    return activeUtilityServices.filter((service) => {
      const isSelectedInStep3 = step3Services.includes(service.name);
      const isNonMetered = !service.isMeterRequired;
      return isSelectedInStep3 && isNonMetered;
    });
  }, [activeUtilityServices, planId]); // Remove getStep3SelectedServices from deps

  // Helper functions to check charge types - REMOVED (inline in useMemo above)

  // Create Service Charge Name options - STABLE
  const serviceChargeNameOptions = useMemo(() => {
    const options = [];

    if (serviceChargeNames && !serviceChargeNamesLoading) {
      const apiChargeNames = serviceChargeNames
        .filter((item: any) => item.isActive)
        .map((item: any) => ({
          label: item.name,
          value: item.name,
        }));
      options.push(...apiChargeNames);
    }

    const serviceOptions = nonMeteredServicesFromStep3.map((service) => ({
      label: service.name,
      value: service.name,
    }));
    options.push(...serviceOptions);

    return options;
  }, [
    serviceChargeNames,
    serviceChargeNamesLoading,
    nonMeteredServicesFromStep3,
  ]);

  // Create Utility Service options
  const utilityServiceOptions = useMemo(() => {
    const options = [{ label: "Common", value: "Common" }];

    if (activeUtilityServices && activeUtilityServices.length > 0) {
      const serviceOptions = activeUtilityServices.map((service) => ({
        label: service.name,
        value: service.name,
      }));
      options.push(...serviceOptions);
    }

    return options;
  }, [activeUtilityServices]);

  // ONLY autopopulate when action is "edit" and data is available (similar to OperationsStep)
  useEffect(() => {
    if (
      action === "edit" &&
      data.serviceCharges &&
      Object.keys(data.serviceCharges).length > 0
    ) {
      const commonCharges = Object.keys(data.serviceCharges).map(
        (chargeKey) => {
          const charge = data.serviceCharges[chargeKey];
          return {
            charge_name: charge.chargeLabel || chargeKey,
            charge_key: chargeKey,
            utility_service:
              charge.utilityService || charge.utility_service || "",
            charge_type: charge.basis || charge.charge_type || "",
            charge_rate: parseFloat(charge.fee || charge.charge_rate || "0"),
            frequency: charge.frequency || "",
            credit_period: charge.creditPeriod
              ? parseInt(charge.creditPeriod)
              : undefined,
            consumption: charge.consumption || "",
            consumption_percentage: charge.consumptionPercentage
              ? parseFloat(charge.consumptionPercentage)
              : undefined,
          };
        }
      );

      const serviceChargesData = {
        common_charges: commonCharges,
      };

      setLocalFormData(serviceChargesData);
      onDataChange?.(serviceChargesData);

      // Set form values directly
      try {
        form.setValue("common_charges", commonCharges);
      } catch (error) {
        console.error("Error setting form values:", error);
      }
    }
  }, [action]);

  // Define monitored parameter item fields for form-array - STABLE REFERENCE
  const serviceChargeItemFields: FormField[] = useMemo(() => {
    // Create stable showWhen functions
    const showForNonMetered = (formData: any) => {
      const chargeName = formData?.charge_name || "";
      if (!chargeName) return false;
      return nonMeteredServicesFromStep3.some(
        (service) => service.name === chargeName
      );
    };

    const showForLatePayment = (formData: any) => {
      const chargeName = formData?.charge_name || "";
      if (!chargeName) return false;
      return (
        chargeName.toLowerCase().includes("late payment") ||
        chargeName.toLowerCase().includes("late_payment")
      );
    };

    const showForRegular = (formData: any) => {
      return !showForNonMetered(formData);
    };

    return [
      {
        name: "charge_name",
        label: "Service Charge Name",
        type: "select",
        required: true,
        placeholder: "Select a charge name or service charge.",
        options: serviceChargeNameOptions,
        helperText:
          "Select a predefined charge name or service-specific charge.",
        disabled: serviceChargeNamesLoading,
        className: "col-span-1",
      },
      {
        name: "utility_service",
        label: "Utility Service",
        type: "select",
        required: false,
        placeholder: "Select utility service",
        options: utilityServiceOptions,
        helperText: "Select the utility service this charge applies to.",
        className: "col-span-1",
      },
      {
        name: "charge_type",
        label: "Service Charge Type",
        type: "select",
        required: false,
        placeholder: "Select charge type",
        options: SERVICE_CHARGE_TYPE_OPTIONS,
        helperText: "Define if the charge is fixed or variable.",
        className: "col-span-1",
        showWhen: showForRegular,
      },
      {
        name: "charge_rate",
        label: "Service Charge Rate",
        type: "decimal",
        required: false,
        placeholder: "0.00",
        helperText: "Enter the rate amount for this charge.",
        className: "col-span-1",
        showWhen: showForRegular,
        validation: {
          min: { value: 0, message: "Rate must be positive" },
        },
      },
      {
        name: "frequency",
        label: "Frequency",
        type: "select",
        required: false,
        placeholder: "Select frequency",
        options: FREQUENCY_OPTIONS,
        helperText: "When this charge is applied.",
        className: "col-span-1",
        showWhen: showForRegular,
      },
      {
        name: "credit_period",
        label: "Credit Period",
        type: "number",
        required: false,
        placeholder: "30",
        suffix: "days",
        helperText: "Grace period before late payment charge applies.",
        className: "col-span-1",
        showWhen: showForLatePayment,
        validation: {
          min: { value: 1, message: "Must be at least 1 day" },
          max: { value: 365, message: "Must be at most 365 days" },
        },
      },
      {
        name: "consumption",
        label: "Consumption",
        type: "select",
        required: false,
        placeholder: "Select consumption type",
        options: CONSUMPTION_OPTIONS,
        helperText: "Select how consumption is calculated for this service.",
        className: "col-span-1",
        showWhen: showForNonMetered,
      },
      {
        name: "consumption_percentage",
        label: "Consumption Percentage",
        type: "number",
        required: false,
        placeholder: "50",
        min: 1,
        max: 100,
        suffix: "%",
        helperText: "Enter the percentage of consumption to be charged.",
        className: "col-span-1",
        showWhen: (formData: any) => {
          const chargeName = formData?.charge_name || "";
          const consumption = formData?.consumption || "";
          const isNonMetered = nonMeteredServicesFromStep3.some(
            (service) => service.name === chargeName
          );
          return isNonMetered && consumption === "partial";
        },
        validation: {
          min: { value: 1, message: "Must be at least 1%" },
          max: { value: 100, message: "Must be at most 100%" },
        },
      },
    ];
  }, [
    serviceChargeNameOptions,
    utilityServiceOptions,
    serviceChargeNamesLoading,
    nonMeteredServicesFromStep3,
  ]);

  // Create form fields (similar to OperationsStep)
  const formFields: FormField[] = useMemo(
    () => [
      {
        name: "common_charges",
        type: "form-array",
        label: "",
        group: "Service Charges",
        groupColorNeeded: false,
        itemFields: serviceChargeItemFields,
        showAddButton: true,
        showRemoveButton: true,
        showReorderButtons: false,
        addButtonText: "Add Charge",
        emptyMessage:
          "No service charges defined yet. Click 'Add Charge' to add charges.",
        helperText: "These charges apply to all services",
        className: "col-span-full",
      },
    ],
    [serviceChargeItemFields]
  );

  // Create form instance
  const form: UseFormReturn<any> = FormService.createForm({
    fields: formFields,
    mode: "onChange",
    validateOnMount: false,
    defaultValues: localFormData,
  });

  // Handle field changes (similar to OperationsStep) - OPTIMIZED
  const handleFieldChange = (fieldName: string, value: any) => {
    // Handle array operations for common_charges
    if (fieldName === "common_charges") {
      const updatedData = {
        common_charges: value,
      };

      setLocalFormData(updatedData);
      onDataChange?.(updatedData);
      return;
    }

    // Handle all other fields
    const updatedData = {
      ...localFormData,
      [fieldName]: value,
    };

    setLocalFormData(updatedData);
    onDataChange?.(updatedData);

    // Clear validation errors
    if (showValidation) {
      setShowValidation(false);
      setValidationErrors([]);
    }

    // Handle charge type for info display
    if (fieldName.includes("charge_type")) {
      setSelectedChargeType(value);
    }
  };

  // Transform to API payload
  const transformToApiPayload = (formData: any): any => {
    const utilityServiceCharges: Record<string, any> = {};

    (formData.common_charges || []).forEach((charge: any) => {
      const key = charge.charge_key || charge.charge_name;

      utilityServiceCharges[key] = {
        chargeLabel: charge.charge_name,
        utility_service: charge.utility_service || null,
        fee: charge.charge_rate != null ? String(charge.charge_rate) : null,
        frequency: charge.frequency || null,
        basis: charge.charge_type || null,
        creditPeriod:
          charge.credit_period != null ? String(charge.credit_period) : null,
        operation: "addition",
        ...(charge.consumption && { consumption: charge.consumption }),
        ...(charge.consumption_percentage != null && {
          consumption_percentage: String(charge.consumption_percentage),
        }),
        ...(utilityId &&
          key.toLowerCase().includes("late_payment") && {
            remote_utility_id: utilityId,
          }),
      };
    });

    return {
      extra_charges: {
        utility_service_charges: utilityServiceCharges,
      },
      current_step: 4,
    };
  };

  // // Business rules validation - SIMPLE
  // const validateServiceChargesData = (
  //   data: any
  // ): { isValid: boolean; errors: string[] } => {
  //   const errors: string[] = [];

  //   if (data.common_charges && data.common_charges.length > 0) {
  //     data.common_charges.forEach((charge: any, index: number) => {
  //       if (!charge.charge_name || charge.charge_name === "") {
  //         errors.push(`Service charge ${index + 1}: Charge name is required`);
  //       }

  //       // Check if it's a non-metered service
  //       const isNonMetered = nonMeteredServicesFromStep3.some(
  //         (service) => service.name === charge.charge_name
  //       );
  //       // Check if it's a late payment charge
  //       const isLatePayment =
  //         charge.charge_name &&
  //         (charge.charge_name.toLowerCase().includes("late payment") ||
  //           charge.charge_name.toLowerCase().includes("late_payment"));

  //       if (!isNonMetered) {
  //         if (!charge.utility_service || charge.utility_service === "") {
  //           errors.push(
  //             `Service charge ${index + 1}: Utility service is required`
  //           );
  //         }
  //         if (!charge.charge_type || charge.charge_type === "") {
  //           errors.push(`Service charge ${index + 1}: Charge type is required`);
  //         }
  //         if (!charge.charge_rate || charge.charge_rate <= 0) {
  //           errors.push(
  //             `Service charge ${index + 1}: Charge rate must be greater than 0`
  //           );
  //         }
  //         if (!charge.frequency || charge.frequency === "") {
  //           errors.push(`Service charge ${index + 1}: Frequency is required`);
  //         }
  //       }

  //       if (isLatePayment) {
  //         if (
  //           !charge.credit_period ||
  //           charge.credit_period < 1 ||
  //           charge.credit_period > 365
  //         ) {
  //           errors.push(
  //             `Service charge ${
  //               index + 1
  //             }: Credit period must be between 1 and 365 days`
  //           );
  //         }
  //       }

  //       if (isNonMetered && charge.consumption === "partial") {
  //         if (
  //           !charge.consumption_percentage ||
  //           charge.consumption_percentage < 1 ||
  //           charge.consumption_percentage > 100
  //         ) {
  //           errors.push(
  //             `Service charge ${
  //               index + 1
  //             }: Consumption percentage must be between 1 and 100`
  //           );
  //         }
  //       }
  //     });
  //   }

  //   return { isValid: errors.length === 0, errors };
  // };

  // Handle next (similar to OperationsStep handleNext) - SIMPLE
  const handleNext = async () => {
    // Clear previous errors first
    setValidationErrors([]);
    setShowValidation(false);
    clearValidationError?.();

    const isValid = await FormService.validateForm(form);

    if (!isValid) {
      const formErrors = form.formState.errors;
      const errorMessages: string[] = [];

      // Collect all error messages from form state
      Object.keys(formErrors).forEach((key) => {
        const error = formErrors[key];
        if (error && typeof error.message === "string") {
          errorMessages.push(error.message);
        }
      });

      if (errorMessages.length > 0) {
        setValidationErrors(errorMessages);
        setShowValidation(true);
      }

      setValidationError?.("Please fill in all required fields.");
      return;
    }

    const formData = form.getValues();
    // const validation = validateServiceChargesData(formData);

    // if (!validation.isValid) {
    //   setValidationErrors(validation.errors);
    //   setShowValidation(true);
    //   return;
    // }

    try {
      const payload = transformToApiPayload(formData);
      setFormLoading(true);

      updatePlanMutation.mutate(payload, {
        onSuccess: (response) => {
          const completedData = {
            ...localFormData,
            payload,
            response,
            isStepComplete: true,
            completedAt: new Date().toISOString(),
          };

          onDataChange?.(completedData);
          navigate("/plan-tarrif/plan-tarrif-landing?tab=plans");
        },
        onError: (err) => {
          console.error("Error updating service charges:", err);
          setValidationError?.(
            "Failed to save service charges. Please try again."
          );
        },
        onSettled: () => {
          setFormLoading(false);
        },
      });
    } catch (error) {
      setValidationError?.("Unexpected error occurred. Please try again.");
      setFormLoading(false);
    }
  };

  const handlePrevious = () => {
    onPrevious?.();
  };

  // Custom footer (similar to OperationsStep) - SIMPLE
  const renderCustomFooter = () => (
    <div className="space-y-4">
      {/* Loading state */}
      {serviceChargeNamesLoading && (
        <div className="p-3 bg-blue-50 border border-blue-200 rounded-md">
          <p className="text-sm text-blue-800">
            <strong>Loading:</strong> Fetching service charge names...
          </p>
        </div>
      )}

      {/* Validation Errors */}
      {showValidation && validationErrors.length > 0 && (
        <div className="p-4 bg-red-50 border border-red-200 rounded-md">
          <div className="flex items-start">
            <AlertCircle className="w-5 h-5 text-red-500 mt-0.5 mr-3 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-red-800">
                Validation Errors
              </h4>
              <ul className="mt-2 space-y-1">
                {validationErrors.map((error, index) => (
                  <li key={index} className="text-sm text-red-700">
                    • {error}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      )}

      {/* Charge Type Information */}
      {selectedChargeType && CHARGE_DESCRIPTIONS[selectedChargeType] && (
        <div className="p-4 bg-blue-50 border border-blue-200 rounded-md">
          <div className="flex items-start">
            <Info className="w-5 h-5 text-blue-500 mt-0.5 mr-3 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-blue-800">
                About {selectedChargeType} Charges
              </h4>
              <p className="mt-1 text-sm text-blue-700">
                {CHARGE_DESCRIPTIONS[selectedChargeType]}
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Navigation Buttons */}
      <div className="flex justify-between pt-6 border-t border-gray-200">
        <button
          type="button"
          onClick={handlePrevious}
          disabled={isFirstStep}
          className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 transition-colors"
        >
          <ChevronLeft className="inline w-4 h-4 mr-1" />
          Previous
        </button>
        <button
          type="button"
          onClick={handleNext}
          disabled={formLoading || loading || serviceChargeNamesLoading}
          className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 flex items-center gap-2 transition-colors"
        >
          {(formLoading || loading) && (
            <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
          )}
          {formLoading || loading ? (
            "Saving..."
          ) : (
            <>
              <CheckCircle className="w-4 h-4" />
              {isEditMode ? "Update Service Charges" : "Save Service Charges"}
            </>
          )}
        </button>
      </div>
    </div>
  );

  return (
    <div className="bg-white p-3">
      <DynamicForm
        fields={formFields}
        form={form}
        onFieldChange={handleFieldChange}
        gridColumns={2}
        responsiveColumns={{
          sm: 1,
          md: 2,
        }}
        renderCustomFooter={renderCustomFooter}
        config={{
          layout: "grid",
          columns: 2,
          showResetButton: false,
          showSubmitButton: false,
          spacing: "medium",
          classes: {
            form: "space-y-8 p-0",
            button: "px-6 py-2 rounded-md font-medium transition-colors",
            buttonContainer: "flex justify-between",
            input:
              "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500",
            select:
              "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500",
            slider: "w-full",
            label: "block text-sm font-medium text-gray-700",
            error: "text-sm text-red-600 mt-1",
            container: "space-y-1",
            helperText: "text-sm text-gray-500 mt-1",
            textarea:
              "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-vertical",
          },
        }}
      />
    </div>
  );
};

export default ServiceChargesStep;
